import { DownloadFile, enqueueSnackbar } from 'actions';

import {
	GetOptOverallsIncidentsRequest,
	GetOptOverallIncidentDetailsRequest,
	GetOptOverallIncidentDropdownsRequest,
	EditOptOverallIncidentDetailsRequest,
	CreateOptOverallIncidentRequest,
	DeleteOptOverallIncidentRequest,
	ExportOptOverallsIncidentsRequest
} from '../requests/OptOverallRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_OPT_OVERALL_TRACKER = 'GET_OPT_OVERALL_TRACKER';
export const TOGGLE_OPT_OVERALL_DIALOG = 'TOGGLE_OPT_OVERALL_DIALOG';
export const GET_OPT_OVERALL_TRACKER_DETAILS = 'GET_OPT_OVERALL_TRACKER_DETAILS';
export const GET_OPT_OVERALL_TRACKER_DROPDOWNS = 'GET_OPT_OVERALL_TRACKER_DROPDOWNS';
export const TOGGLE_DELETE_OPT_OVERALL_DIALOG = 'TOGGLE_DELETE_OPT_OVERALL_DIALOG';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onGetOptOverallsIncidents = (value) => ({
	type: GET_OPT_OVERALL_TRACKER,
	incidents: value
});

const onToggleOptOverallDialog = (visible, tableId) => ({
	type: TOGGLE_OPT_OVERALL_DIALOG,
	visible,
	tableId
});

const onGetOptOverallIncidentDetails = (value) => ({
	type: GET_OPT_OVERALL_TRACKER_DETAILS,
	incidentDetails: value
});

const onGetOptOverallIncidentDropdowns = (value) => ({
	type: GET_OPT_OVERALL_TRACKER_DROPDOWNS,
	dropdowns: value
});

const onToggleDeleteOptOverallDialog = (visible, tableId) => ({
	type: TOGGLE_DELETE_OPT_OVERALL_DIALOG,
	visible,
	tableId
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const GetOptOverallsIncidents = (userId, role) => async (dispatch) => {
	await GetOptOverallsIncidentsRequest(userId, role).then(response => {
		dispatch(onGetOptOverallsIncidents(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleOptOverallDialog = (visible, tableId) => (dispatch) => {
	dispatch(onToggleOptOverallDialog(visible, tableId));
};

export const GetOptOverallIncidentDetails = (userId, tableId) => async (dispatch) => {
	await GetOptOverallIncidentDetailsRequest(userId, tableId).then(response => {
		dispatch(onGetOptOverallIncidentDetails(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetOptOverallIncidentDropdowns = (userId, tableId) => async (dispatch) => {
	await GetOptOverallIncidentDropdownsRequest(userId, tableId).then(response => {
		dispatch(onGetOptOverallIncidentDropdowns(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const EditOptOverallIncidentDetails = (optimizationsOverallDto) => async (dispatch) => {
	await EditOptOverallIncidentDetailsRequest(optimizationsOverallDto).then(response => {
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const CreateOptOverallIncident = (optimizationsOverallDto) => async (dispatch) => {
	await CreateOptOverallIncidentRequest(optimizationsOverallDto).then(response => {
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleDeleteOptOverallDialog = (visible, tableId) => (dispatch) => {
	dispatch(onToggleDeleteOptOverallDialog(visible, tableId));
};

export const DeleteOptOverallIncident = (userId, tableId) => async (dispatch) => {
	await DeleteOptOverallIncidentRequest(userId, tableId).then(response => {
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ExportOptOverallsIncidents = (userId, role) => async (dispatch) => {
	await ExportOptOverallsIncidentsRequest(userId, role).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
